import { render, staticRenderFns } from "./DeviceVideoModal.vue?vue&type=template&id=2c18e010&scoped=true"
import script from "./DeviceVideoModal.vue?vue&type=script&lang=js"
export * from "./DeviceVideoModal.vue?vue&type=script&lang=js"
import style0 from "./DeviceVideoModal.vue?vue&type=style&index=0&id=2c18e010&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c18e010",
  null
  
)

export default component.exports